import { Typography } from '@mui/material';

import { MyConversationsInboxType } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';
import { PageContext } from '@kamernet/core/Page';
import { PageLayout } from '@kamernet/core/PageLayout';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import styles from './Error404.module.css';

export const Error404 = () => {
  const { T, locale } = useIntl();
  const { traceID } = PageContext.useContext();

  return (
    <PageLayout pageTitle={T('LBL_PAGETITLE_APPLICATION_ERROR')}>
      <PageLayout.MainContainer>
        <PageLayout.SectionContainer className={styles.root}>
          <Typography
            fontSize={48}
            variant="body2"
            fontWeight={700}
            marginBottom={3}
          >
            {404}
          </Typography>
          <Typography
            fontSize={28}
            variant="body2"
            fontWeight={600}
            lineHeight={1.2}
            marginBottom={2}
          >
            {T('400_error_page.heading.doesnt_exist')}
          </Typography>
          <Typography variant="body2" marginBottom={2}>
            {T('400_error_page.subheading.helpful_links')}
          </Typography>
          <div className={styles.linksContainer}>
            <div className={styles.links}>
              <NavLink.Anchor
                href={ROUTES.HowDoesItWorkTenant.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_HOW_DOES_IT_WORK_MENU')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyPublicProfile.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_PUBLIC_PROFILE')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.LCFStart.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_CREATE_AD')}
              </NavLink.Anchor>

              <NavLink.Anchor
                href={ROUTES.MySettings.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_SETTINGS')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyListings.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MANAGE_AD')}
              </NavLink.Anchor>
            </div>
            <div className={styles.links}>
              <NavLink.Anchor
                href={ROUTES.MyAccount.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_PREMIUM_ACCOUNT')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyConversations.getURL(
                  { inboxType: MyConversationsInboxType.Default },
                  locale,
                )}
                fontWeight={600}
              >
                {T('LBL_404_MY_MESSAGES')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyFavoriteListings.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_FAVORITE_ROOMS')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyFavoriteTenants.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_FAVORITE_TENANTS')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyAlerts.getURL({}, locale)}
                fontWeight={600}
              >
                {T('LBL_GLOBAL_ALERTS')}
              </NavLink.Anchor>
            </div>
          </div>

          <div className={CommonStyles.margin_top_5}>
            {/* eslint-disable-next-line custom/no-restricted-translation-jsx-untranslated-children-text */}
            <Typography variant="body2">Trace ID: {traceID}</Typography>
          </div>
        </PageLayout.SectionContainer>
      </PageLayout.MainContainer>
    </PageLayout>
  );
};
